"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundingString = exports.LAT_LNG_PRECISION = exports.BASE_ZOOM_LEVEL = void 0;
exports.BASE_ZOOM_LEVEL = 15;
exports.LAT_LNG_PRECISION = 7;
exports.BoundingString = {
    toString: function (center, zoom) {
        var currentZoom = zoom || exports.BASE_ZOOM_LEVEL;
        if (center == null) {
            return "";
        }
        return "@".concat(center.lat.toFixed(exports.LAT_LNG_PRECISION), ",").concat(center.lng.toFixed(exports.LAT_LNG_PRECISION), ",").concat(currentZoom.toFixed(0), "z");
    },
    fromString: function (str) {
        if (typeof str !== 'string') {
            return null;
        }
        if (str.length < 2 || str.charAt(0) !== '@' || str.charAt(str.length - 1) !== 'z') {
            return null;
        }
        var chunks = str.substr(1, str.length - 2).split(',').map(function (val) { return parseFloat(val); });
        var lat = chunks[0], lng = chunks[1], zoom = chunks[2];
        if (isNaN(lat) || isNaN(lng) || isNaN(zoom)) {
            return null;
        }
        if (lat === 0 || lng === 0 || zoom === 0) {
            return null;
        }
        return { lat: lat, lng: lng, zoom: zoom };
    }
};
//# sourceMappingURL=bounding.string.js.map